import {View} from 'pacto';


export class Mediaplayer extends View {

	constructor(options) {
		super(options);
		this._isPlaying = false;
		this._onReceivePlay = this._onReceivePlay.bind(this);
	}

	render() {
		super.render();
		this.context.on('mediaplayer:play', this._onReceivePlay);
		return this;
	}

	play() {
		this._isPlaying = true;
		this.context.trigger('mediaplayer:play', {instance: this});
	}

	pause() {
		if (!this._isPlaying) {
			return;
		}

		this.context.trigger('mediaplayer:pause', {instance: this});
	}

	_onReceivePlay({data: {instance}}) {
		if (instance === this) {
			return;
		}

		if (typeof instance === 'object' && instance._isAutoplay) {
			return;
		}

		this.pause();
	}

}
